import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchScheduleNutritionSaveToLibrarySuggestionArgs,
  FetchOrgScheduleNutritionArgs,
  FetchScheduleNutritionArgs,
} from '../api/types/scheduleNutrition.types';

import {
  fetchScheduleNutritionSaveToLibrarySuggestion,
  fetchOrgScheduleNutrition,
  fetchScheduleNutrition,
} from '../api/scheduleNutrition.api';

export const scheduleNutritionQueryKeys = createQueryKeys('scheduleNutrition', {
  fetchScheduleNutritionSaveToLibrarySuggestion: ({
    eventId,
    organizationId,
  }: FetchScheduleNutritionSaveToLibrarySuggestionArgs) => ({
    queryFn: () =>
      fetchScheduleNutritionSaveToLibrarySuggestion({
        eventId,
        organizationId,
      }),
    queryKey: [organizationId, eventId],
  }),
  fetchOrgScheduleNutrition: ({
    from,
    organizationId,
    to,
  }: FetchOrgScheduleNutritionArgs) => ({
    queryFn: () => fetchOrgScheduleNutrition({ from, organizationId, to }),
    queryKey: [organizationId, from, to],
  }),
  fetchScheduleNutrition: ({
    clientId,
    from,
    organizationId,
    to,
  }: FetchScheduleNutritionArgs) => ({
    queryFn: () =>
      fetchScheduleNutrition({ clientId, from, organizationId, to }),
    queryKey: [organizationId, clientId, from, to],
  }),
});
